module.exports = __webpack_public_path__ + "img/logo-WC-main-nav-drawer.fc68681f.svg";